import { ScrollToTop } from '@breuni-ui/bdk-scroll-to-top';
import { safeDefine } from '@breuni-ui/safe-define';

// empty by intention
class EntsScrollToTop extends ScrollToTop {}

safeDefine('ents-scroll-to-top', EntsScrollToTop);
